$(function(){
$('.js-burger').on('click',function(){
  let $this = $(this);
  let $mobileMenu = $('.js-mobile-menu');
  $this.toggleClass('is-active');
  $mobileMenu.toggleClass('is-show');
});
});

